export default "__VITE_ASSET__CfaVSGHt__"